export default "__VITE_ASSET__C9k5MaGr__"